module.exports = __webpack_public_path__ + "static/img/step06.54ed13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv025/step06.png
// module id = SlT3
// module chunks = 0